"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiOutlinedInput = void 0;
exports.MuiOutlinedInput = {
    styleOverrides: {
        root: {
            "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--input-border-color)",
            },
            ".MuiOutlinedInput-notchedOutline": {
                border: "1px solid var(--input-border-color)",
                borderRadius: "var(--input-border-radius)",
            },
            "&:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--input-focused-border-color)",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--input-focused-border-color)",
                boxShadow: "var(--input-focused-box-shadow)",
                borderWidth: "1px",
                transition: "box-shadow 0.3s",
            },
            "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--input-border-color)",
            },
        },
    },
};
//# sourceMappingURL=MuiOutlinedInput.js.map